var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8dd463;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scribble_1",
    "data-name": "scribble 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.08,692.31c2.76-42.79,26.15-85.72,64.93-104,29.79-14.06,64.18-12.47,97.09-14.16s68.67-8.6,89.81-33.87c19.91-23.8,21.56-57.28,26.23-88s16.81-64.87,45.8-75.94c23.44-9,50.59.45,74.49-7.19,24.78-7.91,40.43-32.14,50.92-55.94s18.39-49.64,36.19-68.61c28.44-30.29,79.32-34.58,114.21-12s52,68.18,43.66,108.89-39.94,75-78.75,89.84c-37.09,14.17-81.47,13-111.28,39.2-27.13,23.88-33.43,62.83-41.69,98s-24.4,74.05-58.74,85.31c-25.86,8.48-57.14-.92-79.32,14.87-13.62,9.69-20,26.77-22.39,43.32s-1.38,33.46-4,50C614,808.94,575.49,849.39,529,859.07,431.8,879.29,368.54,778.33,374.08,692.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects18);
export default __webpack_public_path__ + "static/media/objects-18.4487e44aecc557052062c2f5940d39e8.svg";
export { ForwardRef as ReactComponent };